import React from 'react'
import PropTypes from 'prop-types'

export default function ErrorBubble({ children }) {
  return <div className="c-error-bubble">{children}</div>
}

ErrorBubble.propTypes = {
  children: PropTypes.node.isRequired,
}
